import React, { useState, useEffect, useRef } from 'react';
import { Checkbox, TextInput } from "flowbite-react";
import '../style/textinput.css';

const customStyles = {
  menu: (provided) => ({
    ...provided,
    zIndex: 9999, // very high to appear above modals
    maxHeight: "300px", // taller dropdown
    overflowY: "scroll",
  }),
  control: (provided) => ({
    ...provided,
    minHeight: "48px",
    fontSize: "14px",
  }),
};
const CustomSelectwithText = ({
  value,
  onChange,
  options,
  id,
  name,
  isMulti = false,
  isDisabled = false,
  styles = { customStyles }
}) => {

  useEffect(() => {
    if (value) {
      setCheckedValues(Object.keys(value).map(Number));
      setInputValues(value);
    }
  }, [value]);


  const [inputValues, setInputValues] = useState({});
  const [checkedValues, setCheckedValues] = useState(Array.isArray(value) ? value : []);
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const dropdownRef = useRef(null);

  const handleCheckboxChange = (e, optionValue) => {
    const checked = e.target.checked;
    setCheckedValues((prev) =>
      checked ? [...prev, optionValue] : prev.filter((val) => val !== optionValue)
    );

    setInputValues((prev) => {
      const updatedInputValues = { ...prev };
      if (checked) {
        updatedInputValues[optionValue] = '1';
      } else {
        delete updatedInputValues[optionValue];
      }
      onChange(updatedInputValues);
      return updatedInputValues;
    });
  };

  const handleInputChange = (value, optionValue) => {
    setInputValues((prev) => ({
      ...prev,
      [optionValue]: value,
    }));
    onChange({
      ...inputValues,
      [optionValue]: value,
    });
  };

  const toggleDropdown = () => {
    if (!isDisabled) setIsDropdownVisible(!isDropdownVisible);
  };


  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const filteredOptions = options.filter((option) =>
    option.label.toLowerCase().includes(searchTerm.toLowerCase())
  );

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setIsDropdownVisible(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className="relative rounded-lg">
      <div
        id={id}
        name={name}
        className="border border-gray-300 p-2 cursor-pointer flex flex-wrap gap-2"
        onClick={toggleDropdown}
      >
        {checkedValues.length > 0
          ? checkedValues.map((item) => (
            <div
              key={item}
              className="flex items-center bg-gray-100 border border-gray-300 rounded-lg p-1 gap-1"
            >
              <span className="text-xs">
                {options.find((opt) => opt.value === item)?.label} ({inputValues?.[item] || 0})
              </span>

              <button
                className="text-red-500 text-xs font-extrabold px-2 hover:bg-red-200 rounded"
                onClick={(e) => {
                  if (!isDisabled) {  // Proper conditional check
                    e.stopPropagation();
                    setCheckedValues((prev) => prev.filter((val) => val !== item));
                    setInputValues((prev) => {
                      const updatedInputValues = { ...prev };
                      delete updatedInputValues[item];
                      onChange(updatedInputValues);
                      return updatedInputValues;
                    });
                  }
                }}
              >
                ×
              </button>

            </div>
          ))
          : 'Select options'}
      </div>

      {isDropdownVisible && (
        <div
          ref={dropdownRef}
          className="border border-gray-300 absolute top-full left-0 w-full bg-white p-2 z-[999999] shadow-lg"
          style={{
            maxHeight: "none",      // remove max height so it doesn't scroll
            overflow: "visible",    // prevent internal scroll
          }}
        >
          <div className="bg-white sticky top-0 z-50">
            <TextInput
              type="text"
              value={searchTerm}
              onChange={handleSearchChange}
              placeholder="Search options"
              className="custominput mb-2 w-full text-xs"
            />
          </div>

          {filteredOptions.map((option) => (
            <div
              key={option.value}
              className="flex items-center mb-2 p-1 overflow-hidden"
            >
              <Checkbox
                checked={checkedValues.includes(option.value)}
                onChange={(e) => handleCheckboxChange(e, option.value)}
                className="mr-2"
              />
              <span className="whitespace-nowrap">{option.label}</span>
              {checkedValues.includes(option.value) && (
                <TextInput
                  type="text"
                  value={inputValues[option.value] || ''}
                  onChange={(e) => handleInputChange(e.target.value, option.value)}
                  placeholder="Enter value"
                  className="custominput ml-2 w-35 text-xs"
                  min="1"
                  onKeyDown={(e) => {
                    if (!/[0-9]/.test(e.key) && e.key !== "Backspace" && e.key !== "Tab" && e.key !== "ArrowLeft" && e.key !== "ArrowRight") {
                      e.preventDefault();
                    }
                  }}

                />
              )}
            </div>
          ))}
          {filteredOptions.length === 0 && (
            <div className="text-gray-500 text-xs">No options found</div>
          )}
        </div>
      )}

    </div>
  );
};

export default CustomSelectwithText;
